import React from 'react';
import SlotMachine from './components/SlotMachine';
import './App.css';
import TransactionList from "./components/TransactionList";
import AllTransactions from "./components/AllTransactions"
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import WalletContextProvider from "./WalletContextProvider";
import Navbar from "./components/ShlotMachineNavbar";
import DegenerativePoetryDetailPage from "./components/DegenerativePoetryDetailPage";


function App() {
  return (
      <WalletContextProvider>
      <Router>
        <Navbar/>
              <div className="App">
                  <Routes>
                      <Route path="/" element={<SlotMachine />} />
                      <Route path="/transactions" element={<TransactionList/>} />
                      <Route path="/all-transactions" element={<AllTransactions/>} />
                      <Route path="/poem/:id" element={<DegenerativePoetryDetailPage />} />
                  </Routes>
              </div>
      </Router>
      </WalletContextProvider>
  );
}

export default App;
